import utils from "../utils";
import mapStyle from "../map-style.js";
const map = utils.body.querySelector("#google-map");

function initGoogleMap() {
const google = window.google;

	var latitude = Number(map.getAttribute("data-lat")),
		longitude = Number(map.getAttribute("data-lng")),
		zoom = Number(map.getAttribute("data-zoom")),
		// maxZoom = 15,
		latLng = new google.maps.LatLng(latitude, longitude);

	const mapInstance = new google.maps.Map(map, {
		center: latLng,
		zoom,
		styles: mapStyle,
		disableDefaultUI: true,
	});

	// mapInstance.setOptions({ maxZoom });

	var markerLatitude = Number(map.getAttribute("data-lat")),
		markerLongitude = Number(map.getAttribute("data-lng")),
		markerLatLng = new google.maps.LatLng(markerLatitude, markerLongitude),
		markerImage = {
			url: window.baseUrl + "/images/marker.png",
		};

		new google.maps.Marker({
			position: markerLatLng,
			map: mapInstance,
			icon: markerImage,
		});
}

window.initGoogleMap = initGoogleMap;

if (map) {
	const apiKey = map.getAttribute("data-api");
	utils.loadScript(
		"https://maps.googleapis.com/maps/api/js?callback=initGoogleMap&key=" + apiKey,
		false,
		function () {
		}
	);
}
